import { z } from 'zod';

import { PagedRequestSchema, PagedResultSchema } from './pagingSchema.ts';

export const CreateAssetTypesSchema = z.object({
  name: z.string(),
  description: z.string().min(1).max(100),
  serviceType: z.string(),
});

export const UpdateAssetTypesSchema = z
  .object({
    id: z.uuid(),
  })
  .extend(CreateAssetTypesSchema.shape)
  .omit({ serviceType: true });

export const AssetTypesSchema = CreateAssetTypesSchema.extend({
  id: z.uuid(),
  lastModified: z.string().datetime().optional().nullable(),
});

export const PagedResponseAssetTypesSchema = PagedResultSchema.extend({
  results: z.array(AssetTypesSchema),
});

export const AssetTypeSearchRequestSchema = z
  .object({
    name: z.string().default(''),
  })
  .extend(PagedRequestSchema.shape);

export type CreateAssetTypeModel = z.infer<typeof CreateAssetTypesSchema>;
export type UpdateAssetTypeModel = z.infer<typeof UpdateAssetTypesSchema>;
export type PagedResponseAssetTypesModel = z.infer<
  typeof PagedResponseAssetTypesSchema
>;

export type AssetTypeSearchRequestModel = z.infer<
  typeof AssetTypeSearchRequestSchema
>;
export type BaseAssetTypeModel = z.infer<typeof AssetTypesSchema>;
